import { render, staticRenderFns } from "./crudInstancesSystem.vue?vue&type=template&id=35b1820a&scoped=true&"
import script from "./crudInstancesSystem.vue?vue&type=script&lang=js&"
export * from "./crudInstancesSystem.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesSystem.vue?vue&type=style&index=0&id=35b1820a&prod&lang=css&"
import style1 from "./crudInstancesSystem.vue?vue&type=style&index=1&id=35b1820a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1820a",
  null
  
)

export default component.exports